import { render, staticRenderFns } from "./SearchResultsView.vue?vue&type=template&id=06726db7&scoped=true&"
import script from "./SearchResultsView.vue?vue&type=script&lang=js&"
export * from "./SearchResultsView.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsView.vue?vue&type=style&index=0&id=06726db7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06726db7",
  null
  
)

export default component.exports